import { useState } from "react";

const FAQS = [
  {
    q: "Is there really no credit card required for the free trial?",
    a: "Correct — zero payment info needed. Sign up with your name and email, and you get full Pro access for 14 days, completely free. We'll ask for a card only if you decide to continue.",
  },
  {
    q: "Can I cancel at any time?",
    a: "Yes. You can cancel your subscription at any time from your account dashboard. There's no cancellation fee, and you'll keep access until the end of your billing period.",
  },
  {
    q: "What's the difference between the Basic and Pro plans?",
    a: "The Basic plan is great for occasional gig seekers — you get 10 applications per month and manual apply. Pro unlocks unlimited applications, AI-generated resumes and cover letters, auto-fill apply, priority matching, and profile optimization.",
  },
  {
    q: "How does the Employer plan pricing work?",
    a: "Employer plans are quote-based and scale with your usage. The platform charges a 10–20% commission on each successfully completed job — no monthly subscription unless you want premium features like the candidate dashboard and API access.",
  },
  {
    q: "Can I switch plans mid-month?",
    a: "Absolutely. You can upgrade or downgrade at any time. Upgrades take effect immediately; downgrades apply at the end of your current billing cycle.",
  },
  {
    q: "How does the AI capability matching work?",
    a: "Gig n' Cash's AI analyzes your skills, work history, certifications, and preferences to score each job by compatibility. Jobs with a high match percentage are surfaced first, and you can set alerts for new high-match postings.",
  },
  {
    q: "Is there a refund policy?",
    a: "Yes. If you're not satisfied within the first 30 days of a paid plan, contact our support team and we'll issue a full refund — no questions asked.",
  },
];

export default function PricingFAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="py-16 bg-[#fafafa]">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl font-extrabold text-gray-900 mb-2">Frequently Asked Questions</h2>
          <p className="text-gray-500 text-sm">Everything you need to know about Gig <span className="italic">n&apos;</span> Cash pricing.</p>
        </div>
        <div className="flex flex-col gap-3">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className={`bg-white border rounded-xl overflow-hidden transition-all duration-200 ${open === i ? "border-emerald-200" : "border-gray-200"}`}
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-bold text-gray-900 pr-4">{faq.q}</span>
                <span className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-transform duration-200 ${open === i ? "bg-emerald-50 text-emerald-600 rotate-180" : "bg-gray-100 text-gray-500"}`}>
                  <i className="ri-arrow-down-s-line text-base" />
                </span>
              </button>
              {open === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
